class SentryWrapper {
    isSentryLoaded;
    queue
    constructor() {
        this.isSentryLoaded = false;
        this.queue = [];

        // Dynamicznie dołącz skrypt Sentry
        this.loadSentryScript();
    }

    loadSentryScript() {
        const script = document.createElement('script');
        script.src = 'https://js.sentry-cdn.com/d9baef4f8fb01ff41c94776a9a5eaec4.min.js';
        script.crossOrigin = 'anonymous';
        script.async = true;
        script.defer = true;

        script.onload = () => {
            this.isSentryLoaded = true;
            window.Sentry.onLoad(() => {
                window.Sentry.init({ });
                this.processQueue();
            });
        };

        document.head.appendChild(script);
    }

    captureException(exception) {
        if (this.isSentryLoaded) {
            window.Sentry.captureException(exception, { level: 'error' });
        } else {
            this.queue.push(() => window.Sentry.captureException(exception, { level: 'error' }));
        }
    }

    setTag(key, value) {
        if (this.isSentryLoaded) {
            window.Sentry.setTag(key, value);
        } else {
            this.queue.push(() => window.Sentry.setTag(key, value));
        }
    }

    processQueue() {
        while (this.queue.length > 0) {
            const action = this.queue.shift();
            action();
        }
    }
}

const Sentry = new SentryWrapper();
export default Sentry;




// WEBPACK FOOTER //
// ./src/lib/sentry.js